import './styles.scss';

import { IAccountOption } from '../../../../providers/venue-provider';

import { PnlBody } from './pnl-body';

interface PnlProps {
  accountOption: IAccountOption;
}

const Pnl = ({ accountOption }: PnlProps) => {
  return (
    <div className="pnl-container">
      <PnlBody accountOption={accountOption} />
    </div>
  );
};

export default Pnl;
